import ClientService from '../../../services/client-service';
import getOperationLogDataQuery from '../../../graphql/query/get-operation-log-data.graphql';
import getUserOperationListDataQuery from '../../../graphql/query/get-user-operation-list-data.graphql';
import getEmailOperationListDataQuery from '../../../graphql/query/get-email-operation-list-data.graphql';
import getDealOperationListDataQuery from '../../../graphql/query/get-deal-operation-list-data.graphql';
import getApiOperationListDataQuery from '../../../graphql/query/get-api-operation-list-data.graphql';
import getReportOperationListDataQuery from '../../../graphql/query/get-report-operation-list-data.graphql';
import getErrorMessageListDataQuery from '../../../graphql/query/get-error-message-list-data.graphql';
import getApiOperationDataQuery from '../../../graphql/query/get-api-operation-data.graphql';

export default class SettingsOperationLogApi {
  public static getOperationLogData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getOperationLogDataQuery, payload);
  }

  public static getUserOperationListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getUserOperationListDataQuery, payload);
  }

  public static getEmailOperationListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getEmailOperationListDataQuery, payload);
  }

  public static getDealOperationListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getDealOperationListDataQuery, payload);
  }

  public static getApiOperationListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getApiOperationListDataQuery, payload);
  }

  public static getReportOperationListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getReportOperationListDataQuery, payload);
  }

  public static getErrorMessageListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getErrorMessageListDataQuery, payload);
  }

  public static getApiOperationData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getApiOperationDataQuery, payload);
  }
}
